export default __webpack_public_path__ + "static/media/brave_zone_m1.cae36fa1.png";